
import Jobs from '@/components/Jobs/JobsAll.vue'
export default {
components:{
  Jobs
}

}
